import React, { useContext } from 'react';
import styled from 'styled-components';
import { CellWithArrow as BaseCellWithArrow } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const STATUS = { past: 'pastWage', future: 'futureWage' };

const Wrapper = styled.div`
  white-space: break-spaces;
`;

const CellWithArrow = styled(BaseCellWithArrow)`
  white-space: break-spaces;
`;

const PositionRenderer = ({
  rowData: { subRows, wageStatus, positionId },
  columnData: { mappedPositions },
  isExpended,
  toggleRow
}) => {
  const { t } = useContext(ConfigContext);

  const value = t(STATUS[wageStatus]) || mappedPositions[positionId]?.label || t('baseWage');

  if (!subRows || subRows.length < 1) {
    return <Wrapper>{value}</Wrapper>;
  }

  return (
    <CellWithArrow isExpended={isExpended} toggleRow={toggleRow} multiline>
      {value}
    </CellWithArrow>
  );
};

export default PositionRenderer;
